import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpGuideComponent } from './help-guide.component';

const routes: Routes = [
  {
    path: '',
    component: HelpGuideComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpGuideRoutingModule { }
